import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPropertyLeased,
  IsOwned,
  IsSystemPropertyOwnerRelatedToBorrower,
  IsLoanCategoryEqualTo,
} from '../../rules';
import { BaseRuleset } from '../BaseRuleset';
import { LoanCategory } from '../../../../../../../../../../../types/api';

class PropertyCurrentlyPayingMortgageRuleset
  extends BaseRuleset
  implements Ruleset
{
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isOwned = IsOwned.evaluate(data);
    const isLeased = IsPropertyLeased.evaluate(data);
    const isSystemPropertyOwnerRelatedToBorrower =
      IsSystemPropertyOwnerRelatedToBorrower.evaluate(data);
    const isExpressPropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PROPCO
    ).evaluate(data);
    const isExpressPlusPropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PLUS_PROPCO
    ).evaluate(data);
    const isCorePropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.CORE_PROPCO
    ).evaluate(data);
    const isExpressOpCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_OPCO
    ).evaluate(data);
    const isExpressPlusOpCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PLUS_OPCO
    ).evaluate(data);
    const isCoreOpCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.CORE_OPCO
    ).evaluate(data);

    return isOwned ||
      (isLeased &&
        isSystemPropertyOwnerRelatedToBorrower &&
        (isExpressPropCo ||
          isExpressPlusPropCo ||
          isCorePropCo ||
          isExpressOpCo ||
          isExpressPlusOpCo ||
          isCoreOpCo))
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PropertyCurrentlyPayingMortgageRuleset();
